module.exports = __webpack_public_path__ + "img/barn-images-t5YUoHW6zRo-unsplash.890d91f5.jpg";